import { render, staticRenderFns } from "./VatForm.vue?vue&type=template&id=9053ae68&"
import script from "./VatForm.vue?vue&type=script&lang=ts&"
export * from "./VatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports